import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

export type RemoveFromListButtonProps = {
    isDisabled?: boolean;
    onClick(): void;
} & Pick<IPlainTooltipProps, "tooltipContent">;

const RemoveFromListButton = (props: RemoveFromListButtonProps) => {
    const { isDisabled = false, tooltipContent, onClick } = props;

    return (
        <PlainTooltip
            enabled={!isDisabled}
            tooltipContent={tooltipContent}
        >
            <div>
                <IconButton
                    type="flat"
                    iconName="delete"
                    isDisabled={isDisabled}
                    dataAutomation="remove-from-list-button"
                    onClick={onClick}
                >
                    {translate("si.multi_selector.initial_state.button.remove.label")}
                </IconButton>
            </div>
        </PlainTooltip>
    );
};

export default RemoveFromListButton;
